import { render, staticRenderFns } from "./ConnectFormAccount.vue?vue&type=template&id=512c0c5a&scoped=true"
import script from "./ConnectFormAccount.vue?vue&type=script&lang=js"
export * from "./ConnectFormAccount.vue?vue&type=script&lang=js"
import style0 from "./ConnectFormAccount.vue?vue&type=style&index=0&id=512c0c5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c0c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('512c0c5a')) {
      api.createRecord('512c0c5a', component.options)
    } else {
      api.reload('512c0c5a', component.options)
    }
    module.hot.accept("./ConnectFormAccount.vue?vue&type=template&id=512c0c5a&scoped=true", function () {
      api.rerender('512c0c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/accounts/view/ConnectFormAccount.vue"
export default component.exports